import { ReactElement, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Tabs from '../controls/Tabs';
import UserUnitSettings from '../components/UserUnitSettings';
import UserThresholdSettings from '../components/threshold';
import SequenceEditor from '../components/sequence';

export const TAB_THRESHOLD = 'threshold';
export const TAB_UNITS = 'units';
export const TAB_SEQUENCE = 'sequence';

/**
 * Data component which loads the list of devices and data related to it.
 * @returns - A React element that represents the data component.
 */
export default function ParameterSetupPage(): ReactElement {
  const PARAMETER_TABS = [
    { id: TAB_THRESHOLD, name: 'Threshold' },
    { id: TAB_UNITS, name: 'Units' },
    { id: TAB_SEQUENCE, name: 'Sequence' }
  ];

  const [params, setParams] = useSearchParams({});
  const SEARCH_PARAM_TAB = params.get('tab');
  const SELECTED_TAB = SEARCH_PARAM_TAB || TAB_THRESHOLD;
  const [selectedTab, setSelectedTab] = useState(SELECTED_TAB);

  useEffect(() => {
    const oldParams: { tab?: string } = {};
    if (selectedTab) {
      oldParams.tab = selectedTab;
    }
    setParams(oldParams);
  }, [selectedTab]);

  return (
    <>
      <div className="border-b border-b-gray-800">
        <div className="lg:w-1/3">
          <Tabs
            tabs={PARAMETER_TABS}
            selectedTab={selectedTab}
            onTabClick={setSelectedTab}
            tabType="full-width"
          />
        </div>
      </div>
      {selectedTab === TAB_THRESHOLD && <UserThresholdSettings />}
      {selectedTab === TAB_UNITS && <UserUnitSettings />}
      {selectedTab === TAB_SEQUENCE && <SequenceEditor />}
    </>
  );
}
